import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IMAGE_ADDRESS } from '../../../../../../apis';
import { actionRemoveFromFavoriteList } from '../../../../../../redux/actions/favorites';



const CardFavoriteDesktop = (props) => {

	const { product, key } = props.data;

	const dispatch = useDispatch();

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const removeFromFavList = (e, slug) => {
		e.preventDefault();  // جلوی رفتار پیش‌فرض لینک را می‌گیرد
    	e.stopPropagation(); // مانع از بالا رفتن event به لینک می‌شود

		dispatch(actionRemoveFromFavoriteList(slug));
	};

    return (
    	
    	<div className={`border-complete-b ${key === 0 || key % 2 === 0 ? "border-complete-l" : ""}`} style={{width: "calc(50% + 0px)", marginBottom: "0px", marginLeft: "0px"}}>
			<Link 
				to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} 
				className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full styles_VerticalProductCard--hover__ud7aD FAVORITE_PRODUCT_ITEM"  
			>
				<div data-testid="product-card" className="h-full">
					<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
						<div className="flex items-center justify-start mb-1">
							<div className="text-body2-extra grow">
								<br />
							</div>
						</div>
						<div className="flex grow relative flex-col">
							<div className="">
								<div className="flex items-stretch flex-col relative mb-1">
									<div className="flex items-start mx-auto">
										<div>
											<div aria-hidden="false" aria-label={product.title} style={{width: "150px", height: "150px", lineHeight: "0"}}>
												<picture>
													<LazyLoadImage src={IMAGE_ADDRESS + product.image} width={150} height={150} style={{objectFit: "contain"}} alt={product.title} className="w-full rounded-medium inline-block" />
												</picture>
											</div>
										</div>
										{product.colors &&
										<div className="flex items-center justify-center gap-2 absolute top-0 left-0 flex-col p-1 bg-neutral-000 style_ProductImage__colors--topLeft__iHRie">
											{
												product.colors.split(",").map((color, colorIndex) => (
													<span className="rounded-circle inline-block color_Color__l0PYL border-complete-200" style={{backgroundColor: `#${color}`, width: '8px', height: '8px'}}>
													</span>
												))
											}
										</div>
										}
									</div>
								</div>
							</div>
							<div className="grow flex flex-col items-stretch justify-start">
								<div className="flex items-center justify-start gap-1 flex-wrap mb-1">
									<br />
									<br />
								</div>
								<div>
									<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_VerticalProductCard__productTitle__6zjjN">
										{product.title}
									</h3>
								</div>
								<div className="pt-1 flex flex-col items-stretch justify-between">
									<div className="flex items-center justify-between">
										{ product.discount !== null &&
										<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
											<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪</span>
										</div>
										}
										<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
											<span data-testid="price-final">{product.price ? toPersianDigits(product.priceNum) : 'ناموجود'}
											</span>
											{product.price ?
											<div className="flex">
												<svg style={{ width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
													<use xlinkHref="#toman"></use>
												</svg>
											</div>
											:''
											}
										</div>
									</div>
									<div className="flex items-center justify-between pl-5">
										{ product.oldPrice !== null &&
										<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">
											{toPersianDigits(product.oldPriceNum)}
										</div>
										}
									</div>
								</div>
							</div>
							<div className="flex items-center justify-between mt-2">
								<button onClick={(e) => removeFromFavList(e, product.slug)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--small__4O6Vv styles_btn--neutralOutlined__mLWvq styles_btn--primary__y0GEv rounded-medium ml-3">
									<div className="flex items-center justify-center relative grow">
										<div className="flex ml-2" aria-hidden="false">
											<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-low-emphasis)"}} >
												<use xlinkHref="#delete"></use>
											</svg>
										</div>
									</div>
								</button>
								{/*<a className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--small__4O6Vv styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium grow" target="_blank" href="/product/dkp-20481188/%DA%AF%D9%88%D8%B4%DB%8C-%D9%85%D9%88%D8%A8%D8%A7%DB%8C%D9%84-%D8%A7%D9%BE%D9%84-%D9%85%D8%AF%D9%84-iphone-17-pro-max-zaa-%D8%AA%DA%A9-%D8%B3%DB%8C%D9%85-%DA%A9%D8%A7%D8%B1%D8%AA-esim-%D8%B8%D8%B1%D9%81%DB%8C%D8%AA-256-%DA%AF%DB%8C%DA%AF%D8%A7%D8%A8%D8%A7%DB%8C%D8%AA-%D9%88-%D8%B1%D9%85-12-%DA%AF%DB%8C%DA%AF%D8%A7%D8%A8%D8%A7%DB%8C%D8%AA-%D9%86%D8%A7%D8%AA-%D8%A7%DA%A9%D8%AA%DB%8C%D9%88/">
									<div className="flex items-center justify-center relative grow">
										<div className="flex ml-2" aria-hidden="false">
											<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-primary)"}} >
												<use xlinkHref="#cartOff"></use>
											</svg>
										</div>اضافه به سبد
									</div>
								</a>*/}
							</div>
						</div>

					</article>
				</div>
			</Link>
		</div>

    );
}

export default CardFavoriteDesktop;